import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Field Operations Module Service Stores
 */
export const fieldStores: ServiceStoreConfig[] = [
  {
    name: "field-activity",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "field-activity-hardware-order-relation",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "field-activity-issues",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  // Warranty claims services (moved from financial)
  {
    name: "warranty-claims",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
  {
    name: "warranty-attachments",
    options: {
      enableStorage: true,
      enableErrorNotifications: false,
      idField: "id",
    },
  },
];